// Module
var code = "<div class=\"empty-state\"> <div class=\"empty-state__message\"> <ng-transclude> <p>It seems like you don't have any items yet...</p> </ng-transclude> </div> <p class=\"empty-state__outro\"> </p><div ng-transclude=\"action\"></div> <p></p> </div> ";
// Exports
module.exports = code;